export default __webpack_public_path__ + "static/media/esg-53.40044c16.jpg";